enum VehicleOffering {
  CertifiedPreOwned = 'CertifiedPreOwned',
  New = 'New',
  Unspecified = 'Unspecified',
  Used = 'Used'
}

export default VehicleOffering;
